/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ROUTES, SvgInline, UrlHelper } from "@bms/common";
import cx from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";

import { useEnterAction } from "../../../hooks/useKeyAction";

import "./HeaderSearchIcon.scss";

interface IHeaderSearchIconProps {
  iconUrl?: string;
}

export const HeaderSearchIcon: React.FC<IHeaderSearchIconProps> = ({
  iconUrl,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const handleIconClick = () => {
    if (location.pathname !== ROUTES.SEARCH_SCREEN) {
      history.push({
        pathname: ROUTES.SEARCH_SCREEN,
        state: { focusInput: true },
      });
    }
  };

  const { handleKeyAction } = useEnterAction(handleIconClick);

  const iconClassName = cx("HeaderSearchIcon", {
    "HeaderSearchIcon--isActive": location.pathname === ROUTES.SEARCH_SCREEN,
  });

  if (!iconUrl) return null;

  if (UrlHelper.isSvgUrl(iconUrl)) {
    return (
      <SvgInline
        className={iconClassName}
        url={iconUrl}
        onClick={handleIconClick}
        onKeyDown={handleKeyAction}
        tabIndex={0}
        role="button"
        aria-label={t("MENU_SEARCH")}
      />
    );
  }

  return (
    <img
      alt={t("MENU_SEARCH")}
      className={iconClassName}
      src={iconUrl}
      onClick={handleIconClick}
      onKeyDown={handleKeyAction}
      tabIndex={0}
      role="button"
    />
  );
};
